import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IMuqabalasInitialState } from "./muqabalas.interfaces";

import {
  getAppointmentSlotsAsync,
  createAppointmentSlotAsync,
  updateAppointmentSlotAsync,
  deleteAppointmentSlotAsync,
} from "./muqabalas.services";

const muqabalasAsyncActions = (
  builder: ActionReducerMapBuilder<IMuqabalasInitialState>
) => {
  builder.addCase(getAppointmentSlotsAsync.fulfilled, (state, action) => {
    state.appointmentSlots = action.payload;
  });

  builder.addCase(createAppointmentSlotAsync.fulfilled, (state, action) => {
    if (state.appointmentSlots) {
      state.appointmentSlots.data = [
        ...state.appointmentSlots.data,
        ...action.payload.data,
      ];
    }
  });

  builder.addCase(updateAppointmentSlotAsync.fulfilled, (state, action) => {
    if (state.appointmentSlots) {
      const index = state.appointmentSlots.data.findIndex(
        (plan) => plan.id === action.payload.data.id
      );

      state.appointmentSlots.data[index] = {
        ...state.appointmentSlots.data[index],
        ...action.payload.data,
      };
    }
  });

  builder.addCase(deleteAppointmentSlotAsync.fulfilled, (state, action) => {
    if (state.appointmentSlots) {
      state.appointmentSlots.data = state.appointmentSlots.data.filter(
        (item) => item.id !== action.payload.data
      );
    }
  });
};

export default muqabalasAsyncActions;
